enum ClaimingStatus {
  Off,
  On,
}

export default ClaimingStatus;
